
import { Vue, Component, Prop, Ref, Emit, Watch } from 'vue-property-decorator';
import { types } from '../../api_types';
import T from '../../lang';
import * as time from '../../time';
import * as ui from '../../ui';
import arena_ClarificationList from '../arena/ClarificationList.vue';
import arena_EphemeralGrader from '../arena/EphemeralGrader.vue';
import arena_Runs from '../arena/Runs.vue';
import arena_RunsForCourses from '../arena/RunsForCourses.vue';
import arena_RunSubmitPopup from '../arena/RunSubmitPopup.vue';
import arena_RunDetailsPopup from '../arena/RunDetailsPopup.vue';
import arena_Solvers from '../arena/Solvers.vue';
import problem_Feedback from './Feedback.vue';
import problem_SettingsSummary from './SettingsSummary.vue';
import qualitynomination_DemotionPopup from '../qualitynomination/DemotionPopup.vue';
import qualitynomination_PromotionPopup from '../qualitynomination/PromotionPopup.vue';
import qualitynomination_ReviewerPopup from '../qualitynomination/ReviewerPopup.vue';
import user_Username from '../user/Username.vue';
import omegaup_problemMarkdown from './ProblemMarkdown.vue';
import omegaup_Overlay from '../Overlay.vue';
import problem_soltion from './Solution.vue';

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import {
  faEdit,
  faExclamationTriangle,
  faEyeSlash,
  faBan,
  faExternalLinkAlt,
} from '@fortawesome/free-solid-svg-icons';
import { SubmissionRequest } from '../../arena/submissions';
import { ArenaCourseFeedback } from '../arena/Feedback.vue';
library.add(
  faExclamationTriangle,
  faEdit,
  faEyeSlash,
  faBan,
  faExternalLinkAlt,
);

export interface Tab {
  name: string;
  text: string;
}

export enum PopupDisplayed {
  None,
  RunSubmit,
  RunDetails,
  Promotion,
  Demotion,
  Reviewer,
}

@Component({
  components: {
    FontAwesomeIcon,
    'omegaup-problem-solution': problem_soltion,
    'omegaup-arena-clarification-list': arena_ClarificationList,
    'omegaup-arena-ephemeral-grader': arena_EphemeralGrader,
    'omegaup-arena-runs': arena_Runs,
    'omegaup-arena-runs-for-courses': arena_RunsForCourses,
    'omegaup-arena-runsubmit-popup': arena_RunSubmitPopup,
    'omegaup-arena-rundetails-popup': arena_RunDetailsPopup,
    'omegaup-arena-solvers': arena_Solvers,
    'omegaup-markdown': omegaup_problemMarkdown,
    'omegaup-overlay': omegaup_Overlay,
    'omegaup-username': user_Username,
    'omegaup-problem-feedback': problem_Feedback,
    'omegaup-problem-settings-summary': problem_SettingsSummary,
    'omegaup-quality-nomination-reviewer-popup': qualitynomination_ReviewerPopup,
    'omegaup-quality-nomination-demotion-popup': qualitynomination_DemotionPopup,
    'omegaup-quality-nomination-promotion-popup': qualitynomination_PromotionPopup,
  },
})
export default class ProblemDetails extends Vue {
  @Prop({
    default: () => {
      return [];
    },
  })
  allRuns!: types.Run[];
  @Prop({ default: () => [] }) clarifications!: types.Clarification[];
  @Prop() problem!: types.ProblemInfo;
  @Prop({ default: true }) ephemeralGraderEnabled!: boolean;
  @Prop() solvers!: types.BestSolvers[];
  @Prop() user!: types.UserInfoForProblem;
  @Prop() nominationStatus!: types.NominationStatus;
  @Prop() solutionStatus!: string;
  @Prop({ default: null }) solution!: types.ProblemStatement | null;
  @Prop() runs!: types.Run[];
  @Prop({ default: 0 }) allowedSolutionsToSee!: number;
  @Prop() histogram!: types.Histogram;
  @Prop({ default: PopupDisplayed.None }) popupDisplayed!: PopupDisplayed;
  @Prop() activeTab!: string;
  @Prop() allowUserAddTags!: boolean;
  @Prop() levelTags!: string[];
  @Prop() problemLevel!: string;
  @Prop() publicTags!: string[];
  @Prop() selectedPublicTags!: string[];
  @Prop() selectedPrivateTags!: string[];
  @Prop() hasBeenNominated!: boolean;
  @Prop({ default: false }) inContestOrCourse!: boolean;
  @Prop({ default: null }) runDetailsData!: types.RunDetails | null;
  @Prop({ default: null }) guid!: null | string;
  @Prop({ default: null }) createdGuid!: null | string;
  @Prop({ default: null }) problemAlias!: null | string;
  @Prop({ default: false }) isAdmin!: boolean;
  @Prop({ default: false }) showVisibilityIndicators!: boolean;
  @Prop() nextSubmissionTimestamp!: null | Date;
  @Prop() nextExecutionTimestamp!: null | Date;
  @Prop({ default: false }) shouldShowTabs!: boolean;
  @Prop({ default: false }) isContestFinished!: boolean;
  @Prop({ default: null }) contestAlias!: string | null;
  @Prop() searchResultUsers!: types.ListItem[];
  @Prop() searchResultProblems!: types.ListItem[];
  @Prop({ default: null }) languages!: null | string[];
  @Prop() totalRuns!: number;
  @Prop({ default: false }) requestFeedback!: boolean;
  @Prop({ default: () => new Map<number, ArenaCourseFeedback>() })
  feedbackMap!: Map<number, ArenaCourseFeedback>;
  @Prop({ default: () => new Map<number, ArenaCourseFeedback>() })
  feedbackThreadMap!: Map<number, ArenaCourseFeedback>;
  @Prop({ default: true }) useNewVerdictTable!: boolean;
  @Prop({ default: false }) bookmarkedStatus!: boolean;

  @Ref('statement-markdown')
  readonly statementMarkdown!: omegaup_problemMarkdown;

  PopupDisplayed = PopupDisplayed;
  T = T;
  ui = ui;
  time = time;
  selectedTab = this.activeTab;
  currentClarifications = this.clarifications;
  currentPopupDisplayed = this.popupDisplayed;
  hasUnreadClarifications =
    this.clarifications?.length > 0 && this.activeTab !== 'clarifications';
  currentRunDetailsData = this.runDetailsData;

  get isReKarelProblem(): boolean {
    const languages = this.languages ?? this.problem.languages;
    return languages.includes('rk');
  }

  get karelIdeUrl(): string {
    if (this.isReKarelProblem) {
      return '/rekarel/';
    }
    return `/karel.js/${
      this.problem.sample_input ? `#mundo:${this.problem.sample_input}` : ''
    }`;
  }

  get openInKarelIdeText(): string {
    return this.isReKarelProblem ? T.openInReKarel : T.openInKarelJs;
  }

  get shouldShowEphemeralGrader(): boolean {
    return !this.problem.karel_problem && this.ephemeralGraderEnabled;
  }

  get availableTabs(): Tab[] {
    const tabs = [
      {
        name: 'problems',
        text: T.wordsProblem,
        visible: true,
      },
      {
        name: 'runs',
        text: T.wordsRuns,
        visible: this.user.admin,
      },
      {
        name: 'clarifications',
        text: T.wordsClarifications,
        visible: this.user.admin,
      },
      {
        name: 'solution',
        text: T.wordsSeeSolution,
        visible: true,
      },
    ];
    return tabs.filter((tab) => tab.visible);
  }

  get lastRun(): types.Run | null {
    const runs = this.runsByProblem;
    if (!runs?.length) {
      return null;
    }
    return runs.reduce(function (prev, current) {
      return prev && prev.time.getTime() > current.time.getTime()
        ? prev
        : current;
    });
  }

  get preferredLanguage(): null | string {
    if (!this.lastRun) {
      return this.problem.preferred_language ?? null;
    }
    return this.lastRun.language;
  }

  get clarificationsCount(): string {
    if (this.currentClarifications.length === 0) return '';
    if (this.currentClarifications.length > 9) return '(9+)';
    return `(${this.currentClarifications.length})`;
  }

  get visibilityOfPromotionButton(): boolean {
    return (
      (this.nominationStatus?.tried || this.nominationStatus?.solved) &&
      !this.hasBeenNominated
    );
  }

  get parsedQualityHistogram(): null | number[] {
    const qualityHistogram = this.histogram?.qualityHistogram;
    if (!qualityHistogram) {
      return null;
    }
    return JSON.parse(qualityHistogram);
  }

  get parsedDifficultyHistogram(): null | number[] {
    const difficultyHistogram = this.histogram?.difficultyHistogram;
    if (!difficultyHistogram) {
      return null;
    }
    return JSON.parse(difficultyHistogram);
  }

  get histogramQuality(): number {
    return this.histogram?.quality ?? 0;
  }

  get histogramDifficulty(): number {
    return this.histogram?.difficulty ?? 0;
  }

  get runsByProblem(): types.Run[] {
    return this.runs.filter((run) => run.alias === this.problem.alias);
  }

  get filteredLanguages(): string[] {
    if (!this.languages) {
      return this.problem.languages;
    }
    const languagesSet = new Set(this.languages);
    return this.problem.languages.filter((language) =>
      languagesSet.has(language),
    );
  }

  onNewSubmission(): void {
    if (!this.user.loggedIn) {
      this.$emit('redirect-login-page');
      return;
    }
    this.currentPopupDisplayed = PopupDisplayed.RunSubmit;
    this.$emit('new-submission-popup-displayed');
  }

  onRunDetails(request: SubmissionRequest, tab: string): void {
    this.currentPopupDisplayed = PopupDisplayed.RunDetails;
    this.$emit('show-run', {
      ...request,
      hash: `#${tab}/${this.problemAlias}/show-run:${request.guid}`,
      isAdmin: this.isAdmin,
    });
  }

  onNewPromotion(): void {
    if (!this.user.loggedIn) {
      this.$emit('redirect-login-page');
      return;
    }
    this.currentPopupDisplayed = PopupDisplayed.Promotion;
  }

  onNewPromotionAsReviewer(): void {
    this.currentPopupDisplayed = PopupDisplayed.Reviewer;
  }

  onReportInappropriateProblem(): void {
    this.currentPopupDisplayed = PopupDisplayed.Demotion;
  }

  onPopupDismissed(): void {
    this.currentPopupDisplayed = PopupDisplayed.None;
    this.currentRunDetailsData = null;
    this.$emit('update:activeTab', this.selectedTab);
  }

  onPopupPromotionDismissed(
    qualityPromotionComponent: InstanceType<
      typeof qualitynomination_PromotionPopup
    >,
    isDismissed: boolean,
  ): void {
    this.onPopupDismissed();
    this.$emit('dismiss-promotion', qualityPromotionComponent, isDismissed);
  }

  onProblemRendered(): void {
    // TODO: We should probably refactor how the Markdown component is handled,
    // one for problems (with MathJax and the problem-specific logic) and another
    // for all other uses.
    //
    // It might be better for all of these things, plus the Markdown templating
    // system altogether to be replaced by the Markdown Vue component be able
    // to inject Vue components into the DOM after it's being rendered, so that
    // all the templating and interactivity can be handled by Vue instead of by
    // JavaScript.
    const libinteractiveInterfaceNameElement = this.statementMarkdown.$el.querySelector(
      'span.libinteractive-interface-name',
    ) as HTMLElement;
    if (
      libinteractiveInterfaceNameElement &&
      this.problem.settings?.interactive?.module_name
    ) {
      libinteractiveInterfaceNameElement.innerText = this.problem.settings.interactive.module_name.replace(
        /\.idl$/,
        '',
      );
    }

    const outputOnlyDownloadElement = this.statementMarkdown.$el.querySelector(
      '.output-only-download a',
    );
    if (outputOnlyDownloadElement) {
      outputOnlyDownloadElement.setAttribute(
        'href',
        `/probleminput/${this.problem.alias}/${this.problem.commit}/${this.problem.alias}-input.zip`,
      );
    }

    const libinteractiveDownloadFormElement = this.statementMarkdown.$el.querySelector(
      '.libinteractive-download form',
    ) as HTMLElement;
    if (libinteractiveDownloadFormElement) {
      libinteractiveDownloadFormElement.addEventListener(
        'submit',
        (e: Event) => {
          e.preventDefault();

          const form = e.target as HTMLElement;
          const alias = this.problem.alias;
          const commit = this.problem.commit;
          const os = (form.querySelector('.download-os') as HTMLInputElement)
            ?.value;
          const lang = (form.querySelector(
            '.download-lang',
          ) as HTMLInputElement)?.value;
          const extension = os == 'unix' ? '.tar.bz2' : '.zip';

          ui.navigateTo(
            `${window.location.protocol}//${window.location.host}/templates/${alias}/${commit}/${alias}_${os}_${lang}${extension}`,
          );
        },
      );
    }

    const libinteractiveDownloadLangElement = this.statementMarkdown.$el.querySelector(
      '.libinteractive-download .download-lang',
    ) as HTMLSelectElement;
    if (libinteractiveDownloadLangElement) {
      libinteractiveDownloadLangElement.addEventListener(
        'change',
        (e: Event) => {
          let form = e.target as HTMLElement;
          while (!form.classList.contains('libinteractive-download')) {
            if (!form.parentElement) {
              return;
            }
            form = form.parentElement;
          }
          (form.querySelector(
            '.libinteractive-extension',
          ) as HTMLElement).innerText = libinteractiveDownloadLangElement.value;
        },
      );
    }
  }

  onRunSubmitted(code: string, selectedLanguage: string): void {
    this.$emit('submit-run', {
      code,
      language: selectedLanguage,
      runs: this.runs,
      nominationStatus: this.nominationStatus,
    });
    this.onPopupDismissed();
  }

  onClarificationResponse(response: types.Clarification): void {
    this.$emit('clarification-response', {
      clarification: response,
      target: this,
    });
  }

  @Emit('update:activeTab')
  onTabSelected(tabName: string): string {
    if (this.selectedTab === 'clarifications') {
      this.hasUnreadClarifications = false;
    }
    this.selectedTab = tabName;
    return this.selectedTab;
  }

  @Watch('clarifications')
  onInitialClarificationsChanged(newValue: types.Clarification[]): void {
    this.currentClarifications = newValue;
  }

  @Watch('popupDisplayed')
  onPopupDisplayedChanged(newValue: PopupDisplayed): void {
    this.currentPopupDisplayed = newValue;
    if (newValue === PopupDisplayed.None) return;
    if (newValue === PopupDisplayed.RunSubmit) {
      this.onNewSubmission();
      return;
    }
    if (newValue === PopupDisplayed.Promotion) {
      ui.reportEvent('quality-nomination', 'shown');
      return;
    }
  }

  @Watch('currentClarifications')
  onClarificationsChanged(newValue: types.Clarification[]): void {
    if (this.selectedTab === 'clarifications' || newValue.length === 0) return;
    this.hasUnreadClarifications = true;
  }

  @Watch('runDetailsData')
  onRunDetailsChanged(newValue: types.RunDetails): void {
    this.currentRunDetailsData = newValue;
  }
}
